import React from "react";
import KioskLayout from "components/Layout/KioskLayout";
import KioskShopDetailContent from "components/Kiosk/Shop/KioskShopDetailContent";
import MapRouterMaster from "containers/MapRouterMaster";
import useFetch from "hooks/useFetch";
import useDestination from "hooks/useDestination";
import useGaPageView from "hooks/useGaPageView";
import { mainApiPath } from "api/constants";
import { mapRouterType, screenKeys, gaSettings } from "config/constants";

const KioskShopDetail = (props) => {
  const [error, loading, shopDetail] = useFetch(
    mainApiPath.store + "/" + props.match.params.id
  );

  const destination = useDestination(props.location.search);

  //get slot and floorName for new design requirement
  const query = new URLSearchParams(props.location.search);
  const slot = query.get("slot");
  const floorName = query.get("floorName");

  const gaTitle = gaSettings.kioskShopDetail.title;
  const gaLocation = shopDetail?.title
    ? gaSettings.kioskShopDetail.location + shopDetail.title
    : null;
  useGaPageView({ gaTitle, gaLocation });

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk + "/" + screenKeys.shop}
      left={
        <MapRouterMaster
          type={mapRouterType.pathGuide}
          bannerSrc={shopDetail ? shopDetail.banner : null}
          slotInfo={destination}
          destinationName={shopDetail ? shopDetail.title : null}
          layout={"kiosk"}
        />
      }
      right={
        <KioskShopDetailContent
          loading={loading}
          details={shopDetail ? shopDetail : null}
          floorName={floorName}
          slot={slot}
        />
      }
    />
  );
};

export default KioskShopDetail;
